import { useContext, useEffect, useState } from "react";

import { DataContext } from "@/provider/DataContextProvider.tsx";
import { useGetCustomer } from "@/services/api.ts";
import { BasicCustomerDataTwoFactorMethod } from "@/services/model";
import {
  hasValidPersonalDetails,
  transformBasicCustomerDataToPersonalDetailsForm,
} from "@/utils/customerUtils.ts";

export const useCustomerData = () => {
  const { dataContext, setDataContext } = useContext(DataContext);
  const [twoFactorMethod, setTwoFactorMethod] =
    useState<BasicCustomerDataTwoFactorMethod | null>(null);
  const [customerHasPersonalDetails, setCustomerHasPersonalDetails] = useState<
    boolean | null
  >(null);
  const [selectedCustomerTypeTabIndex, setSelectedCustomerTypeTabIndex] =
    useState(0);

  const isBusinessCustomer = !!dataContext.personalDetails?.organizationName;
  useEffect(() => {
    if (isBusinessCustomer) {
      setSelectedCustomerTypeTabIndex(1);
    }
  }, [isBusinessCustomer]);

  const { data: customerData, isFetching: isLoadingCustomer } =
    useGetCustomer();

  useEffect(() => {
    if (customerData && hasValidPersonalDetails(customerData)) {
      setCustomerHasPersonalDetails(true);
      setDataContext((prev) => ({
        ...prev,
        personalDetails:
          transformBasicCustomerDataToPersonalDetailsForm(customerData),
      }));
    }
  }, [customerData, setDataContext]);

  return {
    twoFactorMethod,
    setTwoFactorMethod,
    customerHasPersonalDetails,
    selectedCustomerTypeTabIndex,
    setSelectedCustomerTypeTabIndex,
    customerData,
    isLoadingCustomer,
    isBusinessCustomer,
  };
};
